import React, { Component } from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Nav, Card, Tab, Button } from 'react-bootstrap'
import moment from 'moment';
import * as Cookies from "es-cookie";
import {
    isMobile
} from "react-device-detect";
import { withRouter } from "react-router-dom";
import './_scheduleExamSection.scss';

class ScheduleExamSection extends Component {
    // "Start Test" unlocks this many seconds before the scheduled start, on the
    // exam's own day. Front-end only: getScheduledExams.status still compares
    // against start_time exactly, so the server grants no early window.
    static EARLY_ENTRY_SECONDS = 5 * 60;

    constructor(props) {
        super(props)
        this.pageSize = 6;
        this.state = {
            subtype: "0",
            allActive: "active",
            mainsActive: "",
            advanceActive: "",
            search: "",
            activeTab: "first",
            // Page number kept per tab so switching tabs preserves position.
            pages: { first: 1, third: 1, fourth: 1 },
            // Bumped every second so countdowns re-render.
            tick: 0,
            isOnline: typeof navigator !== "undefined" && navigator.onLine !== undefined ? navigator.onLine : true,
        }
        // Wall-clock moment the current exam list arrived; used to advance the
        // server's current_time locally so countdowns stay in server time.
        this.receivedAt = Date.now();
    }

    componentDidMount() {
        this.timer = setInterval(() => this.setState((prev) => ({ tick: prev.tick + 1 })), 1000);
        window.addEventListener("online", this.handleConnectionChange);
        window.addEventListener("offline", this.handleConnectionChange);
    }

    handleConnectionChange = () => {
        this.setState({ isOnline: navigator.onLine });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.getScheduledExams !== this.props.getScheduledExams) {
            this.receivedAt = Date.now();
        }
    }

    // ── Server "now" for an exam, advanced by the time since the list loaded ──
    serverNow = (getData) => parseInt(getData.current_time) + Math.floor((Date.now() - this.receivedAt) / 1000);

    // ── "2d 4h" for long waits, "01:12:09" under a day ───────────────────────
    formatCountdown = (seconds) => {
        const s = Math.max(0, seconds);
        const d = Math.floor(s / 86400);
        const h = Math.floor((s % 86400) / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        if (d > 0) return `${d}d ${h}h`;
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(h)}:${pad(m)}:${pad(sec)}`;
    }

    isLive = (getData) => {
        const now = this.serverNow(getData);
        return now >= getData.start_time && now <= getData.end_time;
    }

    // ── Countdown chip for an available exam (starts in / ends in) ───────────
    renderCountdown = (getData) => {
        const now = this.serverNow(getData);
        if (now < getData.start_time) {
            const left = getData.start_time - now;
            return (
                <div className={`sem-countdown ${left <= ScheduleExamSection.EARLY_ENTRY_SECONDS ? 'is-soon' : ''}`}>
                    <i className="fal fa-hourglass-start" />
                    <span>Starts in</span>
                    <strong>{this.formatCountdown(left)}</strong>
                </div>
            );
        }
        return (
            <div className="sem-countdown is-live">
                <i className="fal fa-stopwatch" />
                <span>Ends in</span>
                <strong>{this.formatCountdown(getData.end_time - now)}</strong>
            </div>
        );
    }

    startExam = (data) => {

        let examname = "";
        if (data.short_name != "") {
            examname = data.exam_name + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name;
        }

        localStorage.setItem("sessionid", "0");
        localStorage.setItem("type", "Schedule Exam");
        localStorage.setItem("stype", "schedule_exam");
        localStorage.setItem("exam_paper_id", data.id);
        localStorage.setItem("etype", "schedule");
        localStorage.setItem("examname", examname);
        localStorage.setItem("subexamtype", data.sub_exam_type ? String(data.sub_exam_type) : "1");
        localStorage.setItem("examtype_pattern", "college_schedule_exam");

        if (isMobile == true && Cookies.get("institution_id") == 30) {
            window.location.replace("/student/subject/exam");
        } else {
            this.props.history.push("/student/subject/exam");
        }


    }

    resumeExam = (data) => {

        let examname = "";
        if (data.short_name != "") {
            examname = data.exam_name + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name;
        }

        localStorage.setItem("sessionid", "0");
        localStorage.setItem("type", "Schedule Exam");
        localStorage.setItem("stype", "schedule_exam");
        localStorage.setItem("exam_paper_id", data.id);
        localStorage.setItem("etype", "schedule");
        localStorage.setItem("subexamtype", data.sub_exam_type ? String(data.sub_exam_type) : "1");
        localStorage.setItem("examtype_pattern", "college_schedule_exam");
        localStorage.setItem("resumeExam", true);

        if (isMobile == true && Cookies.get("institution_id") == 30) {
            window.location.replace("/student/subject/exam");
        } else {
            this.props.history.push("/student/subject/exam");
        }
    }

    subtypeClick = (type) => {
        this.setState({
            subtype: type,
            allActive: type == "0" ? "active" : "",
            mainsActive: type == "1" ? "active" : "",
            advanceActive: type == "2" ? "active" : "",
            pages: { first: 1, third: 1, fourth: 1 }
        });
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        window.removeEventListener("online", this.handleConnectionChange);
        window.removeEventListener("offline", this.handleConnectionChange);
    }

    handleResultFunction = (id) => {
        this.props.history.push({
            pathname: "/student/subject/exam-result",
            state: {
                sessionid: id,
                examtype: "college_schedule_exam",
            }
        })
    }

    handleClickExam = (getData) => {
        const examDate = moment.unix(getData.end_time).format("YYYY-MM-DD");
        const todayDate = moment.unix(getData.current_time).format("YYYY-MM-DD");

        const institutionId = Cookies.get("institution_id");

        // Institution 24 → same day = show alert
        if (institutionId == 24 && examDate === todayDate) {
            alert("The result will be available tomorrow.");
            return;
        }

        // Next day → open result
        this.handleResultFunction(getData.exam_session_id);
    };

    handleViewQuestionanswer = (id) => {
        this.props.history.push({
            pathname: "/student/expired/view-question-answer",
            state: {
                exam_paper_id: id,
                examtype: "schedule_exam",
            }
        })
    }

    // ── Resolve the readable exam-type name (NEET / JEE …) for a card ──────────
    examTypeName = (getData) => {
        const found = this.props.studentGlobals.exams.find((data) => data.id == getData.exam_type);
        return found ? found.exam : "";
    }

    // ── Search: reset every tab to page 1 whenever the query changes ──────────
    handleSearch = (e) => {
        this.setState({ search: e.target.value, pages: { first: 1, third: 1, fourth: 1 } });
    }

    clearSearch = () => {
        this.setState({ search: "", pages: { first: 1, third: 1, fourth: 1 } });
    }

    handleTabSelect = (key) => {
        this.setState({ activeTab: key });
    }

    setPage = (tabKey, page) => {
        this.setState((prev) => ({ pages: { ...prev.pages, [tabKey]: page } }));
    }

    // ── Match an exam against the search box (name / type / short / date) ──────
    matchesSearch = (getData, dateUnix) => {
        const q = this.state.search.trim().toLowerCase();
        if (!q) return true;
        const fields = [
            getData.exam_name,
            this.examTypeName(getData),
            getData.short_name,
            moment.unix(dateUnix).format("DD MMM YYYY"),
            moment.unix(dateUnix).format("hh:mm A"),
        ];
        return fields.filter(Boolean).some((f) => String(f).toLowerCase().includes(q));
    }

    filterList = (list, dateKey) => list.filter((d) => this.matchesSearch(d, d[dateKey]));

    // ── Slice a filtered list down to the current page for a tab ──────────────
    getPageItems = (list, tabKey) => {
        const current = this.state.pages[tabKey] || 1;
        const start = (current - 1) * this.pageSize;
        return list.slice(start, start + this.pageSize);
    }

    // ── Build the windowed list of page numbers (with … for large ranges) ─────
    pageNumbers = (totalPages, current) => {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        const pages = [1];
        const left = Math.max(2, current - 1);
        const right = Math.min(totalPages - 1, current + 1);
        if (left > 2) pages.push("…");
        for (let p = left; p <= right; p++) pages.push(p);
        if (right < totalPages - 1) pages.push("…");
        pages.push(totalPages);
        return pages;
    }

    renderPagination = (tabKey, totalItems) => {
        const totalPages = Math.ceil(totalItems / this.pageSize);
        if (totalPages <= 1) return null;
        const current = this.state.pages[tabKey] || 1;

        return (
            <div className="sem-pagination">
                <button
                    type="button"
                    className="sem-page-btn sem-page-arrow"
                    disabled={current === 1}
                    onClick={() => this.setPage(tabKey, current - 1)}
                    aria-label="Previous page"
                >
                    <i className="fal fa-angle-left" />
                </button>

                {this.pageNumbers(totalPages, current).map((p, i) => (
                    p === "…" ? (
                        <span key={`gap-${i}`} className="sem-page-gap">…</span>
                    ) : (
                        <button
                            type="button"
                            key={p}
                            className={`sem-page-btn ${p === current ? 'active' : ''}`}
                            onClick={() => this.setPage(tabKey, p)}
                        >
                            {p}
                        </button>
                    )
                ))}

                <button
                    type="button"
                    className="sem-page-btn sem-page-arrow"
                    disabled={current === totalPages}
                    onClick={() => this.setPage(tabKey, current + 1)}
                    aria-label="Next page"
                >
                    <i className="fal fa-angle-right" />
                </button>
            </div>
        );
    }

    // ── Render one tab's grid: filtered → paginated → cards + pagination ──────
    renderPane = (tabKey, fullList, dateKey, emptyLabel, emptyIcon, cardFor) => {
        const filtered = this.filterList(fullList, dateKey);
        const pageItems = this.getPageItems(filtered, tabKey);
        const searching = this.state.search.trim().length > 0;

        return (
            <React.Fragment>
                {searching && filtered.length > 0 && (
                    <div className="sem-result-count">
                        {filtered.length} result{filtered.length > 1 ? 's' : ''} for “{this.state.search.trim()}”
                    </div>
                )}
                <Row className="sem-grid">
                    {filtered.length === 0
                        ? (searching
                            ? this.renderEmpty(`No exams match “${this.state.search.trim()}”.`, "fal fa-search")
                            : this.renderEmpty(emptyLabel, emptyIcon))
                        : pageItems.map((getData, index) => cardFor(getData, index))}
                </Row>
                {this.renderPagination(tabKey, filtered.length)}
            </React.Fragment>
        );
    }

    // ── Shared filter/sub-type toolbar (Mains/Advance + Exam History) ─────────
    renderToolbar = () => (
        <ul className="sem-toolbar list-inline m-0 p-0">
            {Cookies.get("examid") == "2" ? (
                <React.Fragment>
                    <li className="list-inline-item">
                        <Button
                            onClick={() => this.subtypeClick("0")}
                            variant={`outline-secondary sem-pill ${this.state.allActive}`}
                        >All</Button>
                    </li>
                    <li className="list-inline-item">
                        <Button
                            onClick={() => this.subtypeClick("1")}
                            variant={`outline-secondary sem-pill ${this.state.mainsActive}`}
                        >Mains</Button>
                    </li>
                    <li className="list-inline-item">
                        <Button
                            variant={`outline-secondary sem-pill ${this.state.advanceActive}`}
                            onClick={() => this.subtypeClick("2")}
                        >Advance</Button>
                    </li>
                </React.Fragment>
            ) : ("")}

            <li className="list-inline-item">
                <Link
                    to={{
                        pathname: "/student/subject/exam-history",
                        state: { examtype: "schedule_exam" }
                    }}
                    className="btn btn-outline-primary sem-history-btn">
                    <i className="fal fa-history mr-2" />Exam History
                </Link>
            </li>
        </ul>
    )

    // ── Action button for an available exam (start / resume / locked) ─────────
    renderAvailableAction = (getData) => {
        // No internet → block Start/Resume; the exam can't load or submit offline.
        if (!this.state.isOnline) {
            return (
                <Button type="button" className="sem-btn sem-btn-offline" disabled>
                    <i className="fas fa-wifi-slash mr-2" />No internet
                </Button>
            );
        }

        const now = this.serverNow(getData);
        const isWindowOpen = (moment.unix(getData.start_time).format("DD-MMM-YYYY") == moment.unix(now).format("DD-MMM-YYYY") && parseInt(getData.start_time - ScheduleExamSection.EARLY_ENTRY_SECONDS) < now);

        if (isWindowOpen) {
            if (getData.is_started == true && now > getData.is_started) {
                return (
                    <Button type="button" className="sem-btn sem-btn-resume" onClick={() => this.resumeExam(getData)}>
                        <i className="fal fa-redo-alt mr-2" />Resume Test
                    </Button>
                );
            }
            if (getData.is_access == 1) {
                return (
                    <Button type="button" className="sem-btn sem-btn-start" onClick={() => this.startExam(getData)}>
                        <i className="fal fa-play-circle mr-2" />Start Test
                    </Button>
                );
            }
            return (
                <Button type="button" className="sem-btn sem-btn-locked" onClick={() => alert("You don’t have access. Please contact the administrator.")}>
                    <i className="fal fa-lock mr-2" />Start Test
                </Button>
            );
        }

        if (getData.is_access == 1) {
            return (
                <Button type="button" className="sem-btn sem-btn-disabled" disabled>
                    <i className="fal fa-clock mr-2" />Start Test
                </Button>
            );
        }
        return (
            <Button type="button" className="sem-btn sem-btn-locked" onClick={() => alert("You don’t have access. Please contact the administrator.")}>
                <i className="fal fa-lock mr-2" />Start Test
            </Button>
        );
    }

    // ── "09:30 AM – 12:30 PM", with the end date when it falls on another day ─
    formatTimeRange = (getData) => {
        const start = moment.unix(getData.start_time);
        const end = moment.unix(getData.end_time);
        return `${start.format("hh:mm A")} – ${start.isSame(end, "day") ? end.format("hh:mm A") : end.format("DD MMM, hh:mm A")}`;
    }

    // ── A single stylised exam card ───────────────────────────────────────────
    renderExamCard = ({ getData, index, variant, statusLabel, statusIcon, dateUnix, datePrefix, onClick, action, countdown }) => {
        const examType = this.examTypeName(getData);
        const dateObj = moment.unix(dateUnix);

        return (
            <Col key={getData.id} xl={4} lg={6} md={6} sm={12} xs={12} className="mb-4">
                <div
                    className={`sem-card is-${variant} ${onClick ? 'is-clickable' : ''}`}
                    style={{ animationDelay: `${(index % 12) * 60}ms` }}
                    onClick={onClick}
                    role={onClick ? "button" : undefined}
                    tabIndex={onClick ? 0 : undefined}
                >
                    <span className="sem-card-accent" />

                    <div className="sem-card-top">
                        <span className="sem-type-badge">
                            <i className="fal fa-graduation-cap mr-1" />{examType}
                        </span>
                        <span className={`sem-status is-${variant}`}>
                            <i className={`${statusIcon} mr-1`} />{statusLabel}
                        </span>
                    </div>

                    <h5 className="sem-exam-name" title={getData.exam_name}>{getData.exam_name}</h5>

                    <div className="sem-meta">
                        <span className="sem-meta-item">
                            <i className="fal fa-calendar-alt" />
                            <span>{datePrefix ? `${datePrefix} ` : ''}{dateObj.format("DD MMM YYYY")}</span>
                        </span>
                        <span className="sem-meta-item">
                            <i className="fal fa-clock" />
                            <span>{this.formatTimeRange(getData)}</span>
                        </span>
                    </div>

                    {countdown}

                    {action ? <div className="sem-actions" onClick={(e) => e.stopPropagation()}>{action}</div> : (
                        <div className="sem-hint">
                            <i className="fal fa-chevron-right" />
                        </div>
                    )}
                </div>
            </Col>
        );
    }

    // ── Empty state when a tab has no exams ───────────────────────────────────
    renderEmpty = (label, icon) => (
        <Col xs={12}>
            <div className="sem-empty">
                <i className={icon} />
                <p>{label}</p>
            </div>
        </Col>
    )

    render() {

        // For JEE (examid 2) the Mains/Advance pills filter by sub_exam_type (1 = Mains, 2 = Advance).
        // Other exams have no sub-type pills, so the filter is a no-op for them.
        const isJeeSubtype = Cookies.get("examid") == "2";
        const matchesSubtype = (data) => !isJeeSubtype || this.state.subtype == "0" || String(data.sub_exam_type) === String(this.state.subtype);
        const scheduledExams = this.props.getScheduledExams.filter(matchesSubtype);

        // Use getData.current_time for all current time logic
        const currentexams = scheduledExams.filter((data) => (((data.current_time > data.start_time && data.current_time <= data.end_time && data.is_completed == false) || (data.current_time < data.start_time))));

        const compexams = scheduledExams.filter((data) => data.is_completed == true);

        const expiredexams = scheduledExams.filter((data) => {
            if (typeof data.current_time === 'undefined') return false;
            return data.current_time > data.end_time && data.is_completed == false;
        });

        return (
            <div className="schedule_exams schedule-exam-modern pt-xl-4 pt-lg-4 px-xl-4 px-lg-4">
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <h5 className="sem-page-title mb-3">
                            <span className="sem-title-bar" />Schedule Exam
                        </h5>
                        {!this.state.isOnline && (
                            <div className="sem-offline-banner mb-3">
                                <i className="fal fa-exclamation-triangle" />
                                <span>You're offline. Check your internet connection before starting or resuming an exam.</span>
                            </div>
                        )}
                    </Col>
                </Row>

                <Tab.Container id="schedule-exams-tabs" activeKey={this.state.activeTab} onSelect={this.handleTabSelect}>
                    <Card className="sem-shell border-0">
                        <Card.Header className="sem-shell-head border-0">
                            <div className="sem-head-row d-md-flex justify-content-between align-items-center">
                                <Nav variant="pills" className="sem-tabs">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">
                                            <i className="fal fa-bolt mr-2" />Available
                                            <span className="sem-count">{currentexams.length}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="third">
                                            <i className="fal fa-check-circle mr-2" />Completed
                                            <span className="sem-count">{compexams.length}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="fourth">
                                            <i className="fal fa-hourglass-end mr-2" />Expired
                                            <span className="sem-count">{expiredexams.length}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                {this.renderToolbar()}
                            </div>

                            {/* ── Search bar ───────────────────────────────── */}
                            <div className="sem-search">
                                <i className="fal fa-search sem-search-ico" />
                                <input
                                    type="text"
                                    className="sem-search-input"
                                    placeholder="Search by exam name, type or date…"
                                    value={this.state.search}
                                    onChange={this.handleSearch}
                                />
                                {this.state.search ? (
                                    <button type="button" className="sem-search-clear" onClick={this.clearSearch} aria-label="Clear search">
                                        <i className="fal fa-times" />
                                    </button>
                                ) : null}
                            </div>
                        </Card.Header>

                        <Card.Body className="sem-shell-body p-0">
                            <Tab.Content>
                                {/* ── Available ─────────────────────────────── */}
                                <Tab.Pane eventKey="first">
                                    {this.renderPane(
                                        "first", currentexams, "start_time",
                                        "No available exams right now.", "fal fa-clipboard-list",
                                        (getData, index) => {
                                            const live = this.isLive(getData);
                                            return this.renderExamCard({
                                                getData, index,
                                                variant: live ? "available" : "upcoming",
                                                statusLabel: live ? "Live" : "Upcoming",
                                                statusIcon: live ? "fas fa-circle" : "fal fa-calendar-alt",
                                                dateUnix: getData.start_time,
                                                datePrefix: "Starts",
                                                countdown: this.renderCountdown(getData),
                                                action: this.renderAvailableAction(getData),
                                            });
                                        }
                                    )}
                                </Tab.Pane>

                                {/* ── Completed ─────────────────────────────── */}
                                <Tab.Pane eventKey="third">
                                    {this.renderPane(
                                        "third", compexams, "start_time",
                                        "You haven't completed any exams yet.", "fal fa-check-circle",
                                        (getData, index) => this.renderExamCard({
                                            getData, index,
                                            variant: "completed",
                                            statusLabel: "Completed",
                                            statusIcon: "fas fa-check",
                                            dateUnix: getData.start_time,
                                            datePrefix: "",
                                            onClick: () => this.handleClickExam(getData),
                                        })
                                    )}
                                </Tab.Pane>

                                {/* ── Expired ───────────────────────────────── */}
                                <Tab.Pane eventKey="fourth">
                                    {this.renderPane(
                                        "fourth", expiredexams, "end_time",
                                        "No expired exams.", "fal fa-hourglass-end",
                                        (getData, index) => this.renderExamCard({
                                            getData, index,
                                            variant: "expired",
                                            statusLabel: "Expired",
                                            statusIcon: "fas fa-times",
                                            dateUnix: getData.end_time,
                                            datePrefix: "Ended",
                                            onClick: () => this.handleViewQuestionanswer(getData.id),
                                        })
                                    )}
                                </Tab.Pane>
                            </Tab.Content>
                        </Card.Body>
                    </Card>
                </Tab.Container>
            </div>
        )
    }
}

export default withRouter((ScheduleExamSection));
